// extracted by mini-css-extract-plugin
export var NFTCardCominSoon = "NFTCard-module--NFTCardCominSoon--IgR5k";
export var NFTCardbottomContainer = "NFTCard-module--NFTCardbottomContainer--WMRIW";
export var NFTCardcircleContainer = "NFTCard-module--NFTCardcircleContainer--ABjal";
export var NFTcard = "NFTCard-module--NFTcard--tdCG+";
export var nftCardBackgroundImg = "NFTCard-module--nftCardBackgroundImg--U3XwL";